import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { loadContract } from "../../../../store/actions/user";

import Success from "./Success";

const mapDispatchToProps = { loadContract };

export default withRouter(connect(null, mapDispatchToProps)(Success));
